<template>
	<div class="my-order-pay-page">
		
		<!-- 面包屑导航 -->
		<div class="breadcrumb f-bct  animate__animated  ">
			<div class="breadcrumb-inner" @click="$router.back()">
				<span class="crumb-label">{{$t('shopSuss.t1')}}</span>
				<span class="crumb-home">{{$t('omsg.t2')}}</span>
				<el-image class="crumb-sep" :src="require('@/static/CodeBuddyAssets/31159_1817/14.svg')"></el-image>
				<span class="crumb-current">{{$t('myOrderPay.t1')}}</span>
			</div>
			<!-- 返回按钮 -->
			<div class="back-btn" @click="$router.back()">
				<span>{{ $t('header.breadcrumb.backBtn') }}</span>
				<el-image class="back-icon" :src="require('@/static/CodeBuddyAssets/31159_2065/7.svg')"></el-image>
			</div>
		</div>

		<!-- ===== 支付卡片 ===== -->
		<div class="pay-card animate__animated  ">
			<!-- 标题 -->
			<div class="pay-title-row">
				<el-image class="pay-title-icon" :src="require('@/static/CodeBuddyAssets/30865_3657/27.svg')"></el-image>
				<h3 class="pay-title">{{$t('myOrderPay.t2')}}</h3>
			</div>

			<div class="pay-body">
				<!-- 左侧：扫码支付 -->
				<div class="pay-left">
					<!-- <el-image class="qr-code" :src="require('@/static/CodeBuddyAssets/30865_3657/36.png')" :preview-src-list="[require('@/static/CodeBuddyAssets/30865_3657/36.png')]" fit="cover"></el-image> -->
					<div class="pay-amount-area">
						<div class="pay-amount-row">
							<span class="amount-label">{{$t('myOrderPay.t3')}}</span>
							<span class="amount-value">
								<span class="amt-symbol">￥</span>
								<span class="amt-number">{{ orderMsg.actuallyPrice }}</span>
							</span>
						</div>
						<div class="pay-hint">
							<div class="paySelUItem" :class="payType==1?'sela':''" @click="payType=1">
								<el-image :src="require('@/static/CodeBuddyAssets/30865_3657/29.svg')"></el-image>
								<p>{{$t('shopOrder.t28')}}</p>
							</div>
							<div class="paySelUItem" :class="payType==2?'sela':''" @click="payType=2">
								<el-image :src="require('@/static/CodeBuddyAssets/30865_3657/28.svg')"></el-image>
								<p>{{$t('shopOrder.t29')}}</p>
							</div>
							<div class="paySelUItem" :class="payType==3?'sela':''" @click="payType=3">
								<el-image :src="require('@/static/add2/64.png')"></el-image>
								<p>{{$t('shopOrder.t30')}}（{{userInfo.money}}）</p>
							</div>
						</div>
						<div class="pay-timer">
							<span class="timer-label">{{$t('myOrderPay.t4')}}</span>
							<span class="timer-count">{{ obj.minutes }}:{{ obj.seconds }}</span>
							<span class="timer-hint">{{$t('myOrderPay.t5')}}</span>
						</div>
					</div>
				</div>

				<!-- 中间：分隔线 -->
				<div class="pay-divider"></div>

				<!-- 右侧：线下转账 -->
				<div class="pay-right">
					<div class="transfer-header">
						<div class="transfer-check" @click="transferChecked = !transferChecked">
							<el-image :src="require('@/static/CodeBuddyAssets/30865_3657/30.svg')" class="check-circle"></el-image>
							<el-image class="check-dot" :src="require('@/static/CodeBuddyAssets/30865_3657/31.svg')"></el-image>
						</div>
						<span class="transfer-title">{{$t('myOrderPay.t6')}}</span>
					</div>
					<p class="transfer-desc">{{$t('myOrderPay.t7')}}</p>
					<div class="transfer-btn" @click="transferDialogVisible = true">{{$t('myOrderPay.t8')}}</div>
				</div>
				
			</div>
		</div>

		<!-- ===== 确认支付按钮 ===== -->
		<div class="confirm-row">
			<div class="confirm-btn" @click="submitPay">{{$t('myOrderPay.t9')}}</div>
		</div>
		
		
		<!-- 微信支付弹出框 -->
		<el-dialog
			:visible.sync="wxPayHb"
			width="564px"
			custom-class="transfer-dialog"
			:show-close="false"
			:close-on-click-modal="true">
			<div slot="title" class="td-header">
				<h3 class="td-title">{{$t('shopOrder.t42')}}</h3>
				<el-image class="td-close" :src="require('@/static/CodeBuddyAssets/30934_7523/1.svg')" @click="wxPayHb = false"></el-image>
			</div>
			<div class="td-body">
				<el-image class="maImg" :src="wxpayImg"></el-image>
			</div>
			<div slot="footer" class="td-footer">
				<div class="td-btn td-btn-back" @click="wxPayHb = false">{{$t('shopSuss.t4')}}</div>
				<div class="td-btn td-btn-submit" @click="getorderdetailPd">{{$t('shopOrder.t44')}}</div>
			</div>
		</el-dialog>
		
		<!-- ====== 线下转账弹窗 (Figma 30934_7523) ====== -->
		<el-dialog
			:visible.sync="transferDialogVisible"
			width="764px"
			custom-class="transfer-dialog"
			:show-close="false"
			:close-on-click-modal="true">
			<div slot="title" class="td-header">
				<h3 class="td-title">{{$t('myOrderPay.t6')}}</h3>
				<el-image class="td-close" :src="require('@/static/CodeBuddyAssets/30934_7523/1.svg')" @click="transferDialogVisible = false"></el-image>
			</div>
			<div class="td-body">
				<div class="td-info-card">
					<div class="td-info-row">
						<span class="td-info-label">{{$t('myOrderPay.t10')}}</span>
						<span class="td-info-value">{{pzMsg.payeeAccount||$t('omsg.t21')}}</span>
						<span class="td-info-label td-label-left">{{$t('myOrderPay.t11')}}</span>
						<span class="td-info-value">{{pzMsg.payee}}</span>
						<el-image class="td-copy-icon" @click="copy_txt(pzMsg.payeeAccount)" :src="require('@/static/CodeBuddyAssets/30934_7523/2.svg')"></el-image>
					</div>
					<div class="td-info-row">
						<span class="td-info-label">{{$t('myOrderPay.t12')}}</span>
						<span class="td-info-value">{{pzMsg.payeeBank}}</span>
						<span class="td-info-label td-label-left">{{$t('omsg.t28')}}</span>
						<span class="td-info-value">{{orderMsg.orderSn}}</span>
					</div>
					<div class="td-info-row">
						<span class="td-info-label">{{$t('myOrderPay.t13')}}</span>
						<span class="td-info-value">￥{{orderMsg.actuallyPrice}}</span>
					</div>
				</div>
				<div class="td-remark-row">
					<span class="td-remark-label">{{$t('myOrderPay.t14')}}</span>
					<div class="td-remark-input">
						<el-input v-model="transferAccount" :placeholder="$t('myOrderPay.t15')" size="medium"></el-input>
					</div>
				</div>
				<div class="td-remark-row">
					<span class="td-remark-label">{{$t('myOrderPay.t16')}}</span>
					<div class="td-remark-input">
						<el-input v-model="transferInfo" :placeholder="$t('myOrderPay.t17')" size="medium"></el-input>
					</div>
				</div>
				<div class="td-remark-row">
					<span class="td-remark-label">{{$t('myOrderPay.t18')}}</span>
					<div class="td-remark-input">
						<el-upload accept="image/png, image/jpeg"
							class="avatar-uploader"
							:action="uplink"
							:show-file-list="false"
							:on-change="uplinkportrait">
							<el-image class="avatar-img" v-if="transferImage" :src="transferImage"></el-image>
							<el-image class="avatar-img" v-else :src="require('@/static/add2/65.png')"></el-image>
						</el-upload>
					</div>
				</div>
			</div>
			<div slot="footer" class="td-footer">
				<div class="td-btn td-btn-back" @click="transferDialogVisible = false">{{$t('shopSuss.t4')}}</div>
				<div class="td-btn td-btn-submit" @click="submitTransfer">{{$t('myOrderPay.t19')}}</div>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
import {
	configbase,
	authMemberinfo,
	transportOrderdetail,
	transportOrderpay,
} from "/src/api/api.js"
let iv;
let payPd;
export default {
	name: 'MyOrderPay',
	data() {
		return {
			id:0,
			orderMsg:'',
			orderPastTime:'',
			obj:'',
			payType:1,
			// 微信支付弹出框
			wxPayHb:false,
			wxpayImg:'',
			// 线下转账
			pzMsg:'',
			transferDialogVisible:false,
			transferAccount:'',
			transferInfo:'',
			transferImage:'',
		}
	},
	mounted() {
		if(this.$route.query.id){
			this.id = this.$route.query.id*1
		}
		this.configbase()
		this.getinfo()
	},
	methods: {
		// 确认支付
		async submitPay(){
			clearInterval(payPd);
			if(this.payType==2){
				payPd = setInterval(()=>{
					this.getorderdetailPd()
				},1000)
				var url = `http://generalappapi.zhilongapp.com/app/transportOrder/pay?orderId=${this.id}&payType=${this.payType}&payEnv=3`
				window.open(url, '_blank');
				return
			}
			var data = {
				orderId:this.id,
				payType:this.payType,
				payEnv:3,
			}
			const res = await transportOrderpay(data)
			if(res.code==200){
				if(this.payType==1){
					this.wxPayHb = true
					this.wxpayImg = res.msg
				}
				if(this.payType==3){
					this.Tips(res.msg)
					this.back()
				}
			}else{this.Tips(res.msg,'error')}
		},
		// 订单详情 判断
		async getorderdetailPd(){
			const res = await orderdetail({orderPayId:this.id})
			if(res.code==200){
				if(res.data.payStatus){
					clearInterval(payPd);
					this.Tips(res.msg)
					this.back()
				}else{
					if(this.wxPayHb){
						this.Tips(this.$t('shopOrder.t45'),'error')
					}
				}
			}else{this.Tips(res.msg,'error')}
		},
		// 提交线下转账
		async submitTransfer(){
			var data = {
				orderId:this.id,
				payType:4,
				transferAccount:this.transferAccount,
				transferInfo:this.transferInfo,
				transferImage:this.transferImage,
				payEnv:3,
			}
			const res = await transportOrderpay(data)
			if(res.code==200){
				this.Tips(res.msg)
				this.transferDialogVisible = false
				this.back()
			}else{this.Tips(res.msg,'error')}
		},
		// ===== 图片上传 =====
		uplinkportrait(file) {
			if(file.response){
				this.transferImage = file.response.data.url;
			}
		},
		// 基本配置
		async configbase(){
			const res = await configbase({})
			if(res.code==200){
				this.pzMsg = res.data
				this.orderPastTime = res.data.orderPastTime
				// 订单支付详情
				this.getorderdetail()
			}else{this.Tips(res.msg,'error')}
		},
		// 订单详情
		async getorderdetail(){
			const res = await transportOrderdetail({id:this.id})
			if(res.code==200){
				this.orderMsg = res.data.order
				this.obj = this.getTimeLeft(res.data.order.createTime,this.orderPastTime)
				iv = setInterval(()=>{
					this.obj = this.getTimeLeft(res.data.order.createTime,this.orderPastTime)
					if(!this.obj.seconds){
						clearInterval(iv);
						this.back()
					}
				},1000)
			}else{this.Tips(res.msg,'error')}
		},
		// 获取用户信息
		async getinfo(){
			const res = await authMemberinfo({});
			if(res.code==200){
				this.$store.commit('userMsg/userInfoC',res.data);
			}else{this.Tips(res.msg,'error')}
		},
		//取倒计时（天时分秒）
		getTimeLeft(datetimeTo,fen){
			// 计算目标与现在时间差（毫秒） 时间格式  2021-10-14 00:00:00   
			// ios需转换格式为  2021/10/14 00:00:00
			// ios时间兼容格式转换
			datetimeTo = datetimeTo.replace(new RegExp('-', 'g'), '/');
			// 时间转时间搓
			let time1 = new Date(datetimeTo).getTime();
			let time2 = new Date().getTime();
			if(fen){
				time1 = time1+fen*60000
			}
			let mss = time1 - time2;
			// 倒计时结束
			if (mss < 0) {
				var obj = {
					days: 0,
					hours: 0,
					minutes: 0,
					seconds: 0,
				}
				return obj
			}
			// 将时间差（毫秒）格式为：天时分秒
			let days = parseInt(mss / (1000 * 60 * 60 * 24));
			let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
			let seconds = parseInt((mss % (1000 * 60)) / 1000);
			if(days<10){
				days = '0'+days
			}
			if(hours<10){
				hours = '0'+hours
			}
			if(minutes<10){
				minutes = '0'+minutes
			}
			if(seconds<10){
				seconds = '0'+seconds
			}
			var obj = {
				days: days,
				hours: hours,
				minutes: minutes,
				seconds: seconds,
			}
			return obj
		},
	},
	beforeDestroy(){
		clearInterval(iv);
		clearInterval(payPd);
	},
}
</script>

<style lang="scss" scoped>
.my-order-pay-page {
	width: 100%;
	min-height: 100vh;
	background: #F8F8F8;
	padding-bottom: 60px;
}
::v-deep .el-dialog__header{
	padding: 0;
}
::v-deep .el-dialog__body{
	padding-bottom: 0;
}
::v-deep .td-body{
	padding: 0;
}
/* ===== 面包屑 ===== */
.breadcrumb {
	padding: 0 12px;
	padding-top: 24px;
	background: transparent;
}
.breadcrumb-inner {
	display: flex;
	align-items: center;
}
.crumb-label {
	font-size: 0.16rem;
	font-weight: 400;
	color: #333333;
}
.crumb-home {
	font-size: 0.16rem;
	font-weight: 400;
	color: #666666;
	cursor: pointer;
	transition: color 0.3s;
	&:hover { color: #0096FF; }
}
.crumb-sep {
	width: 0.12rem;
	height: 0.12rem;
	margin: 0 0.06rem;
}
.crumb-current {
	font-size: 0.16rem;
	font-weight: 400;
	color: #0096FF;
}
/* ===== 返回按钮 ===== */
.back-btn {
	display: flex;
	align-items: center;
	cursor: pointer;
	transition: opacity 0.3s;
	&:hover { opacity: 0.75; }
	span {
		font-size: 0.16rem;
		font-weight: 400;
		color: #0096FF;
	}
	.back-icon {
		width: 0.18rem;
		height: 0.18rem;
		margin-left: 0.06rem;
	}
}

/* ===== 支付卡片 ===== */
.pay-card {
	width: 1596px;
	margin: 16px auto 0;
	background: #fff;
	border-radius: 12px;
	padding: 24px 32px 32px;
	box-sizing: border-box;
}

.pay-title-row {
	display: flex;
	align-items: center;
	margin-bottom: 28px;
}
.pay-title-icon { width: 4px; height: 16px; margin-right: 12px; }
.pay-title { font-size: 20px; font-weight: 500; color: #333; margin: 0; }

.pay-body {
	display: flex;
	align-items: flex-start;
}

/* 左：扫码支付 */
.pay-left {
	display: flex;
	align-items: flex-start;
	width: 50%;
}
.qr-code {
	width: 158px;
	height: 158px;
	flex-shrink: 0;
	cursor: pointer;
}
.pay-amount-area {
	margin-left: 25px;
}
.pay-amount-row {
	display: flex;
	align-items: baseline;
}
.amount-label {
	font-size: 18px;
	color: #333;
	font-weight: 400;
}
.amount-value {
	margin-left: 8px;
	color: #FC3C3C;
}
.amt-symbol {
	font-size: 20px;
	font-weight: 500;
	font-family: 'MiSans', sans-serif;
}
.amt-number {
	font-size: 36px;
	font-weight: 600;
	font-family: 'MiSans', sans-serif;
}

.pay-hint {
	display: flex;
	align-items: center;
	margin-top: 18px;
	.paySelUItem{
		display: flex;
		align-items: center;
		border: 1px solid #ccc;
		border-radius: 4px;
		padding: 10px 24px;
		margin-right: 12px;
		cursor: pointer;
		p{
			font-size: 14px;
		}
	}
	.sela{
		border: 1px solid #0096FF;
		p{
			color: #0096FF;
		}
	}
}

.pay-hint .el-image {
	width: 30px;
	height: 30px;
	margin-right: 10px;
}

.pay-hint .el-image:last-of-type {
	// margin-left: 6px;
}

.hint-text {
	font-size: 16px;
	color: #999;
	margin-left: 8px;
}

.pay-timer {
	margin-top: 36px;
	font-size: 16px;
}
.timer-label {
	color: #333;
}
.timer-count {
	color: #FC3C3C;
	margin: 0 4px;
}
.timer-hint {
	color: #333;
}

/* 中：分隔线 */
.pay-divider {
	width: 1px;
	height: 133px;
	background: #E8E8E8;
	margin: 0 60px;
	flex-shrink: 0;
	align-self: center;
}

/* 右：线下转账 */
.pay-right {
	flex: 1;
}
.transfer-header {
	display: flex;
	align-items: center;
}
.transfer-check {
	width: 30px;
	height: 30px;
	position: relative;
	cursor: pointer;
}
.check-circle {
	width: 30px;
	height: 30px;
}
.check-dot {
	position: absolute;
	left: 6px;
	top: 6px;
	width: 18px;
	height: 18px;
}
.transfer-title {
	font-size: 18px;
	font-weight: 500;
	color: #333;
	margin-left: 12px;
}

.transfer-desc {
	font-size: 18px;
	color: #999;
	margin: 24px 0;
	line-height: 1.5;
}

.transfer-btn {
	width: 362px;
	height: 52px;
	border: 1px solid #DBDBDB;
	border-radius: 6px;
	text-align: center;
	line-height: 52px;
	font-size: 18px;
	color: #333;
	font-weight: 400;
	cursor: pointer;
	transition: border-color 0.3s;
}
.transfer-btn:hover {
	border-color: #0096FF;
	color: #0096FF;
}

/* ===================================================================
   线下转账弹窗 (Figma 30934_7523)
   =================================================================== */
.td-header {
	height: 69px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: #f8f8f8;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	padding: 0 30px;
}
.td-title {
	font-size: 18px;
	font-weight: 500;
	color: #2F3541;
	margin: 0;
}
.td-close {
	width: 16px;
	height: 16px;
	cursor: pointer;
}

.td-body {
	background: #fff;
	padding: 22px 26px;
	.maImg{
		width: 240px;
		height: 240px;
		margin:auto;
		display: block;
	}
}
.td-info-card {
	// width: 706px;
	height: 120px;
	background: #FAFAFA;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	padding: 20px;
	box-sizing: border-box;
}
.td-info-row {
	margin-bottom: 8px;
	position: relative;
}
.td-info-row:last-child {
	margin-bottom: 0;
}
.td-info-label {
	font-size: 14px;
	color: #999AA3;
}
.td-label-left {
	margin-left: 20px;
}
.td-info-value {
	font-size: 14px;
	color: #2F3541;
}
.td-copy-icon {
	width: 16px;
	height: 16px;
	position: absolute;
	right: 0;
	top: 0;
	cursor: pointer;
}

.td-remark-row {
	display: flex;
	align-items: center;
	margin-top: 20px;
}
.td-remark-label {
	font-size: 16px;
	color: #333;
	font-weight: 400;
	flex-shrink: 0;
	margin-right: 16px;
}
.td-remark-input {
	flex: 1;
	.avatar-img {
		width: 0.90rem;
		height: 0.90rem;
		border-radius: 0.06rem;
		flex-shrink: 0;
	}
}
.td-remark-input ::v-deep .el-input__inner {
	height: 50px;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	font-size: 14px;
	color: #333;
	padding-left: 16px;
}
.td-remark-input ::v-deep .el-input__inner::placeholder {
	color: #C6C6C6;
}

.td-footer {
	display: flex;
	justify-content: flex-end;
	padding: 16px 24px 24px;
	background: #fff;
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;
}
.td-btn {
	width: 120px;
	height: 44px;
	border-radius: 6px;
	text-align: center;
	line-height: 44px;
	font-size: 16px;
	cursor: pointer;
	margin-left: 14px;
	transition: background 0.3s;
}
.td-btn-back {
	background: #E9F6FF;
	color: #0096FF;
}
.td-btn-submit {
	background: #0096FF;
	color: #fff;
}
.td-btn-submit:hover {
	background: #33ABFF;
}

/* ===== 确认支付按钮 ===== */
.confirm-row {
	width: 1596px;
	margin: 24px auto 0;
	display: flex;
	justify-content: flex-end;
}
.confirm-btn {
	width: 184px;
	height: 60px;
	background: #0096FF;
	border-radius: 10px;
	color: #fff;
	font-size: 18px;
	font-weight: 500;
	text-align: center;
	line-height: 60px;
	cursor: pointer;
	transition: background 0.3s;
}
.confirm-btn:hover {
	background: #33ABFF;
}
</style>
